import {quickViewHeightCorrectionStyles} from '@aboutyou/ui-components';
import React from 'react';
import {AppInstallBannerStyle} from './HeaderInstallBannerWrapper';
import {
  APP_INSTALL_BANNER_LAST_CLOSED,
  DISABLE_APP_INSTALL_BANNER,
  TEMPORARILY_DISABLE_APP_INSTALL_BANNER,
} from './useIsBannerOpen';

/**
 * This snippet is used to detect if the app install banner should be shown or not.
 * This sets a css variable on body level to hide the app install banner even before the js bundle gets loaded on the client.
 */
export const DetectAppInstallBannerShowSnippet = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
        (function () {
          try {
            if(!localStorage) return;
            var lastClosedValueInLocalStorage = localStorage.getItem('${APP_INSTALL_BANNER_LAST_CLOSED}');

            var hasPreviouslyClosed = lastClosedValueInLocalStorage && lastClosedValueInLocalStorage !== '""';

            const timeDiffInDays = hasPreviouslyClosed && Math.round((Date.now() - new Date(lastClosedValueInLocalStorage).getTime()) / (1000 * 3600 * 24));
            const lastClosedLessThan15DaysAgo = hasPreviouslyClosed && timeDiffInDays < 15;

            const shouldBeDisabledInPathnames = ['/checkout'];

            const searchParams = new URLSearchParams(window.location.search);
            var isDisabledByUrlParam = searchParams.get('${DISABLE_APP_INSTALL_BANNER}') === '1';
            var isTemporarilyDisabled = searchParams.get('${TEMPORARILY_DISABLE_APP_INSTALL_BANNER}') === '0';
            var isDisabledByPathname = shouldBeDisabledInPathnames.includes(window.location.pathname);
            var supportedBrowser = /android/i.test(window.navigator.userAgent) || /iP(ad|hone|od)/.test(window.navigator.userAgent);

            const disable = isDisabledByPathname || isTemporarilyDisabled || lastClosedLessThan15DaysAgo || isDisabledByUrlParam || !supportedBrowser;

            function setCssVariable(cssVariable, value) {
              document.body.style.setProperty(cssVariable, value);
            }
            if (disable) {
              setCssVariable("${AppInstallBannerStyle.bottomOffsetCssVariable}", "${AppInstallBannerStyle.bottomOffsetWhenHidden}");
              setCssVariable("${quickViewHeightCorrectionStyles.quickViewHeightCorrection}", "${quickViewHeightCorrectionStyles.heightCorrectionWhenInstallBannerIsClosed}");
            } else {
              setCssVariable("${AppInstallBannerStyle.bottomOffsetCssVariable}", "${AppInstallBannerStyle.bottomOffsetWhenShown}");
              setCssVariable("${quickViewHeightCorrectionStyles.quickViewHeightCorrection}", "${quickViewHeightCorrectionStyles.heightCorrectionWhenInstallBannerIsOpen}");
            }
          } catch (e) {
            console.error('Error setting css variable for AppInstallBanner', e);
          }
        })();
        `,
      }}
    ></script>
  );
};
